<app-modal #internalModal [modalConfig]="modalConfig">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    (click)="closeModal()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="container" *ngIf="sessionType">
    <div class="row">
      <div class="col-12">
        <div class="fs-18 mb-2">Hide "{{ sessionType.title }}"?</div>
        <p class="mb-0">
          This session type will be hidden from use in this district. Existing
          data will be preserved and still appear in reports. You can restore it
          at any time.
        </p>
      </div>
    </div>
  </div>
  <div class="w-100 d-flex justify-content-between" footerContent>
    <button (click)="closeModal()" class="btn btn-reset">Cancel</button>
    <button (click)="continue()" class="btn btn-primary">Yes, hide it</button>
  </div>
</app-modal>
